import { Injector } from '@angular/core';
import { Location } from '@angular/common';
export class ServiceLocator {
  static injector: Injector;
  static location: Location;
}
